import { createSelector } from '@reduxjs/toolkit'

import { RootState } from '../../../store/types'
import { clientContextCompanyUserByIdSelector } from '../../clientContext/store/clientContextSelectors'
import { CompanyReducerState } from '../types'

function companyStateSelector<K extends keyof CompanyReducerState>(
  state: RootState,
  key: K,
) {
  return state.company[key]
}

// Simple selectors
export const companyMemberInvitationSelector = (state: RootState) =>
  companyStateSelector(state, 'memberInvitation')

export const companyMemberInvitationSignUpStepSelector = (state: RootState) =>
  companyStateSelector(state, 'memberInvitationSignUpStep')

export const companyMemberInvitationSignUpErrorSelector = (state: RootState) =>
  companyStateSelector(state, 'memberInvitationSignUpError')

export const createdCompanyMemberCustomerIdSelector = (state: RootState) =>
  companyStateSelector(state, 'createdMemberAccount')?.customerId

export const companyVerificationPendingMemberIdSelector = (state: RootState) =>
  companyStateSelector(state, 'verificationPendingMemberId')

export const companyPendingProfileSwitchMemberIdSelector = (state: RootState) =>
  companyStateSelector(state, 'pendingProfileSwitchMemberId')

// Combined selectors
export const companyVerificationPendingMemberSelector = createSelector(
  [companyVerificationPendingMemberIdSelector, state => state],
  (companyMemberId, state) =>
    clientContextCompanyUserByIdSelector(state, companyMemberId ?? ''),
)
